import React from "react";

/**
 * BrandMark — CartIQ 360 lockup.
 *
 * Two colour variants:
 *   • default (dark): white/light text — used inside the authed dashboard
 *     and every existing dark surface (Intelligence, Upload, Pricing…).
 *   • light:          near-black text with green sub-text — used on the
 *     redesigned public Landing page (2026-06-25 palette overhaul).
 *
 * Responsive: on mobile the tagline is hidden and the logo shrinks, so the
 * header doesn't get cramped alongside the About + Auth + CTA buttons.
 */
export const BrandMark = ({ size = "md", sub = true, light = false }) => {
  const primary =
    size === "lg"
      ? "text-2xl sm:text-3xl md:text-4xl"
      : size === "sm"
      ? "text-sm sm:text-base"
      : "text-base sm:text-xl md:text-2xl";
  const logoBox =
    size === "lg"
      ? "w-10 h-10 sm:w-12 sm:h-12"
      : size === "sm"
      ? "w-7 h-7 sm:w-8 sm:h-8"
      : "w-8 h-8 sm:w-10 sm:h-10";

  const primaryColor = light ? "text-[#111111]" : "text-[#F0EDE8]";
  const subColor = light ? "text-[#639922]" : "text-[#888]";

  return (
    <div className="flex items-center gap-2 sm:gap-3 min-w-0" data-testid="brand-mark">
      <img
        src="/cartiq360-logo-256.png"
        alt="CartIQ 360"
        className={`${logoBox} object-contain shrink-0`}
        data-testid="brand-logo"
      />
      <div className="leading-tight min-w-0">
        <div
          className={`font-display uppercase truncate ${primaryColor} ${primary}`}
        >
          CartIQ <span className="text-[#FF6B00]">360</span>
        </div>
        {sub && (
          <div
            className={`hidden sm:block text-[9px] md:text-[10px] tracking-[0.18em] uppercase font-semibold ${subColor}`}
          >
            by Solutionist
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandMark;
